/**
 * Platform Icon Helper
 * Returns the appropriate icon for a platform type
 */

import { Icon } from "@introist/react-foundation/v2";
import { SlackIcon, TeamsIcon } from "../../assets";

export const getPlatformIcon = (platform: string) => {
  if (platform.startsWith("slack")) {
    return <SlackIcon />;
  }

  switch (platform) {
    case "slack":
      return <SlackIcon />;
    case "teams":
      return <TeamsIcon />;
    case "web":
      return <Icon name="globe" />;
    default:
      return <Icon name="globe" />;
  }
};
